import { faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown, Space } from 'antd';
import type { ItemType } from 'antd/es/menu/interface';
import React from 'react';
import { useAuth } from 'react-oidc-context';
import Navigation from './Navigation';
import TenantSelect from './TenantSelect';
import useMenuItems from './useMenuItems';
import FancyButton from '../base/FancyButton';
import { useNavigate } from 'react-router-dom';

const DesktopHeader = () => {
  const { user } = useAuth();
  const menuItems = useMenuItems();
  const navigate = useNavigate();

  return (
    <div className="flex w-full justify-between border-b-[#efefef] border-b bg-white">
      <div className="w-[200px] flex items-center pl-5 py-3">
        <TenantSelect />
      </div>
      <div className="flex-1 flex justify-center items-center">
        <Navigation />
      </div>
      <div className="w-[200px] flex items-center justify-end space-x-5 pr-5">
        <FancyButton onClick={() => navigate('/tasks')}>
          Neue Aufgabe
        </FancyButton>

        <Dropdown
          menu={{
            items: [
              {
                key: 'username',
                label: user?.profile.email ?? '',
                disabled: true,
              },
              ...menuItems.map((item) => {
                if (!item.label) {
                  return {
                    type: 'divider',
                  } satisfies ItemType;
                }

                return {
                  key: item.key,
                  label: (
                    <Space>
                      {item.icon && (
                        <div className="w-5">
                          <FontAwesomeIcon icon={item.icon} />
                        </div>
                      )}
                      <span>{item.label}</span>
                    </Space>
                  ),
                  onClick: item.onClick,
                };
              }),
            ],
          }}
          trigger={['click']}
        >
          <a
            onClick={(e) => e.preventDefault()}
            className="flex items-center cursor-pointer space-x-2 bg-white rounded-full w-[40px] h-[40px] justify-center"
          >
            <FontAwesomeIcon icon={faUser} size="xs" />
          </a>
        </Dropdown>
      </div>
    </div>
  );
};

export default DesktopHeader;
